














































































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import ContactInfo from "@/views/permits/RockCrushing/ContactInfo.vue";
import fieldData, { RecyclingFacility } from "@/ts/FormData";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { ISelectItemVueModel } from "@/ts/models/ISelectItemVueModel";
import { IRockCrushingPermitVueModel } from "../../../ts/models/IRockCrushingPermitVueModel";
import {IRockCrushingFacilityVueModel} from "@/ts/models/IRockCrushingFacilityVueModel";
import {IRockCrushingSection30393VueModel} from "@/ts/models/IRockCrushingSection30393VueModel";
import {IDataVueModel} from "@/ts/models/IDataVueModel";

@Component({
    props: {
        form: {
            type: Object as () => IRockCrushingPermitVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        ContactInfo
    }
})
export default class RockCrushingAcceptedMaterials extends Vue {
    name: string = "AcceptedMaterials";
    title: string = "";
    index: number = NaN;
    pendingFile: string = "";

    errorMsgs = ErrorMessages;

    mounted(): void {
        this.initializeComponent("AcceptedMaterials");

        if (this.$props.form.acceptedMaterials.length === 0) {
            this.$props.form.acceptedMaterials = RecyclingFacility.rockCrushingAcceptedMaterials;
        } else {
            (this.$props.form.acceptedMaterials as ISelectItemVueModel[]).forEach((am, ix, arr) => {
                if (func.isNullOrEmpty(am.id)) {
                    am.id = fieldData.getNewId();
                }
            });
        }
        
        if (this.$props.form.incidentalDebrisFacilities == null) {
          this.$props.form.incidentalDebrisFacilities = [];
        }

      if (this.$props.form.crushedReprocessedMaterialFacilities == null) {
        this.$props.form.crushedReprocessedMaterialFacilities = [];
      }
      
      if (this.$props.form.section30393Items == null || this.$props.form.section30393Items.length === 0) {
        this.$props.form.section30393Items = [];
        // this.$props.form.section30393Items.push({facility: 'School', direction: ''} as IRockCrushingSection30393VueModel);
        // this.$props.form.section30393Items.push({facility: 'Childcare Facility', direction: ''} as IRockCrushingSection30393VueModel);
        // this.$props.form.section30393Items.push({facility: 'Hospital', direction: ''} as IRockCrushingSection30393VueModel);
        // this.$props.form.section30393Items.push({facility: 'Residential/Mixed Occupancy Building', direction: ''} as IRockCrushingSection30393VueModel);
        // this.$props.form.section30393Items.push({facility: 'Other Building', direction: ''} as IRockCrushingSection30393VueModel);
        // this.$props.form.section30393Items.push({facility: 'Public Way', direction: ''} as IRockCrushingSection30393VueModel);
        // this.$props.form.section30393Items.push({facility: 'Park', direction: ''} as IRockCrushingSection30393VueModel);
      }
      
      if (this.$props.form.poConsentFile === null) {
        this.$props.form.poConsentFile = '';
      }
      if (this.$props.form.dustSuppressionPlan === null) {
        this.$props.form.dustSuppressionPlan = '';
      }
      if (this.$props.form.siteSketch === null) {
        this.$props.form.siteSketch = '';
      }
    }

  updateFilesTRC(): void {

    let initial = document.getElementById("files-trc") as HTMLInputElement;
    let files = initial.files as FileList;
    if (files.length === 0) return;

    var fileTypeList = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/pdf", "image/jpeg", "image/png"]
    if (!fileTypeList.includes(files[0].type)) {
      this.$toaster.error("Invalid file type.");
      return;
    }

    // for every file added we want to add a new element placeholder for that file
    // setting the 'multiple' attribute on the input only allows selecting multiple files in one go from the same directory
    // by having single file selection and adding multiple inputs, we have the flexibility to add as many files we want from multiple locations
    let input = document.createElement("input") as HTMLInputElement;
    input.id = fieldData.getNewId();
    input.setAttribute("type", "file");
    input.setAttribute("prefix", "files");

    // set the new elements file to the currently selected file
    //input.files = files;
    if ((this.$parent as any).fileList == null)
    {
      (this.$parent as any).fileList = [];
    }
    (this.$parent as any).fileList.push(files[0]);
    (document.getElementById("attachments") as HTMLElement).append(input);

    // remove the currently selected file from the active input control
    initial.setAttribute("files-trc", "");

    // update our list of current files on the form
    this.$props.form.attachments.push({ id: "new", value: input.id, text: files[0].name });
    if (this.pendingFile === 'PO') {
      this.$props.form.poConsentFile = files[0].name;
    } else if (this.pendingFile === 'DS') {
      this.$props.form.dustSuppressionPlan = files[0].name;
    } else if (this.pendingFile === 'SS') {
      this.$props.form.siteSketch = files[0].name;
    }
    this.pendingFile = "";
  }

  deleteAttachment(fileId: string, fileType: string): void {
    // I'm pretty sure this isn't the correct way to do this...
    this.removeFileTRC(fileId, fileType);
  }

  removeFileTRC(fileId: string, fileType: string): void {
    let item = (this.$props.form.attachments as IDataVueModel[]).find(a => a.value === fileId);
    // since all '.id' properties do not get serialized we are reusing it as an indicator
    if (this.$props.isRenewal) {
      (this.$parent as any).removeFileElement(fileId, "");
      (this.$parent as any).removeFileData(fileId);
      return;
    }
    if (item !== undefined && (item as IDataVueModel).id === "new") {
      (this.$parent as any).removeFileElement(fileId, "");
      (this.$parent as any).removeFileData(fileId);
      this.$toaster.success("File Deleted");
      if (fileType == 'PO') {
        this.$props.form.poConsentFile = "";
      } else if (fileType == 'DS') {
        this.$props.form.dustSuppressionPlan = "";
      } else if (fileType == 'SS') {
        this.$props.form.siteSketch = "";
      }
      this.pendingFile = "";
    } else {
      this.$swal({
        type: "warning",
        title: "Delete File?",
        text: "This Change Can Not be Undone.",
        showCancelButton: true,
        showConfirmButton: true
      }).then(result => {
        if (result.value) {
          (this.$parent as any).isLoading = true;
          (this.$parent as any).onFileDeleting(fileId);
          (this.$parent as any).removeFileElement(fileId, "exists");
          (this.$parent as any).removeFileData(fileId);
          if (fileType == 'PO') {
            this.$props.form.poConsentFile = "";
          } else if (fileType == 'DS') {
            this.$props.form.dustSuppressionPlan = "";
          } else if (fileType == 'SS') {
            this.$props.form.siteSketch = "";
          }
          this.pendingFile = "";
        }
      });
    }
  }
    
  addNewCrushedReprocessed(): void {
      this.$props.form.crushedReprocessedMaterialFacilities.push({})
  }

  removeCrushedReprocessed(index: number) : void {
      this.$props.form.crushedReprocessedMaterialFacilities = this.$props.form.crushedReprocessedMaterialFacilities.filter((e: IRockCrushingFacilityVueModel, i: number) => i !== index);
  }

  removeIncidentalDebris(index: number) : void {
    this.$props.form.incidentalDebrisFacilities = this.$props.form.incidentalDebrisFacilities.filter((e: IRockCrushingFacilityVueModel, i: number) => i !== index);
  }
  
  addNewIncidentalDebris(): void {
    this.$props.form.incidentalDebrisFacilities.push({})
  }

  addNewSection30393(): void {
      this.$props.form.section30393Items.push({})
  }
  
  removeSection30393(index: number): void {
    this.$props.form.section30393Items = this.$props.form.section30393Items.filter((e: IRockCrushingSection30393VueModel, i: number) => i !== index);
  }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;
        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    get isMaterialsError(): boolean {
        return !(this.$props.form.acceptedMaterials as ISelectItemVueModel[]).some(value => value.isSelected);
    }

  get isFilesError(): boolean {
    return this.$props.form.attachments.length < 3;
  }

  triggerClickEvent(inputName: string): void {
    // reverting to JS? sure, why not?!
    if (inputName === 'PO' && this.$props.form.poConsentFile && this.$props.form.poConsentFile.length > 0) {
       const file = (this.$props.form.attachments as IDataVueModel[]).find(x => x.text === this.$props.form.poConsentFile)
      if (file) {
        this.removeFileTRC(file.value, inputName);
      }
      else {
        this.$props.form.poConsentFile = "";
      }
    } else if (inputName === 'DS' && this.$props.form.dustSuppressionPlan && this.$props.form.dustSuppressionPlan.length > 0) {
      const file = (this.$props.form.attachments as IDataVueModel[]).find(x => x.text === this.$props.form.dustSuppressionPlan)
      if (file) {
        this.removeFileTRC(file.value, inputName);
      }
      else {
        this.$props.form.dustSuppressionPlan = "";
      }
    } else if (inputName === 'SS' && this.$props.form.siteSketch && this.$props.form.siteSketch.length > 0) {
      const file = (this.$props.form.attachments as IDataVueModel[]).find(x => x.text === this.$props.form.siteSketch)
      if (file) {
        this.removeFileTRC(file.value, inputName);
      }
      else {
        this.$props.form.siteSketch = "";
      }
    }
    else {
      this.pendingFile = inputName;
      (document.getElementById('files-trc') as HTMLElement).click();
    }
  }

    private getIsOptionSelected(opt: number): boolean {
        let item = (this.$props.form.acceptedMaterials as ISelectItemVueModel[]).find(value => value.name.endsWith(`*${opt}`));
        if (item === undefined || item === null) return false;
        return (item as ISelectItemVueModel).isSelected;
    }
    
    // ADD validations here:
  get isPoConsentFileError(): boolean {
      return func.isNullOrEmpty(this.$props.form.poConsentFile);
  }
  
  get isMEstimateQuantityError(): boolean {
      return func.isNullOrEmpty(this.$props.form.mEstimateQuantity);
  }
  
  get isMMaterialCalculatedError(): boolean {
      return func.isNullOrEmpty(this.$props.form.mMaterialCalculated);
  }
  
  get isMStockpilesError(): boolean {
      return func.isNullOrEmpty(this.$props.form.mStockpiles);
  }
  
  get isMEndUseReprocessedError(): boolean {
      return func.isNullOrEmpty(this.$props.form.mEndUseReprocessed);
  }
  
  get isMEndUsePropertyError(): boolean {
      return func.isNullOrEmpty(this.$props.form.mEndUseProperty)
  }
  
  get isNoiseControlError(): boolean {
      return func.isNullOrEmpty(this.$props.form.noiseControl);
  }
  
  get isDustEmissionError(): boolean {
      return func.isNullOrEmpty(this.$props.form.dustEmission);
  }
  
  get isDustSuppressionFileError(): boolean {
      return func.isNullOrEmpty(this.$props.form.dustSuppressionPlan);
  }
  
  get isTrackoutError(): boolean {
      return func.isNullOrEmpty(this.$props.form.trackout);
  }
  
  get isSiteSketchError(): boolean {
      return func.isNullOrEmpty(this.$props.form.siteSketch);
  }
  
  get section30393FeetError() : boolean {
      return this.$props.form.section30393Items.filter((x : IRockCrushingSection30393VueModel) => func.isNullOrEmpty(x.feet.toString())).length > 0;
  }
  get section30393DirectionError() : boolean {
    return this.$props.form.section30393Items.filter((x: IRockCrushingSection30393VueModel) => func.isNullOrEmpty(x.direction)).length > 0;
  }

    get hasErrors(): boolean {
        return this.isFilesError || this.isPoConsentFileError || this.isMaterialsError || this.isMEstimateQuantityError
            ||this.isMMaterialCalculatedError || this.isMStockpilesError || this.isMEndUseReprocessedError || this.isMEndUsePropertyError
            || this.isNoiseControlError || this.isDustEmissionError || this.isDustSuppressionFileError || this.isTrackoutError
            || this.isSiteSketchError || this.section30393DirectionError || this.section30393FeetError;
    }
}
